module.exports = __webpack_public_path__ + "media/icons/i-4-components-9f436f99.png";